const footerNav = [
  { label: "首页", href: "#top" },
  { label: "热门现场", href: "#hot" },
  { label: "分类频道", href: "#channel" },
  { label: "弹幕现场", href: "#live" },
  { label: "话题广场", href: "#topics" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-800 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-8 md:mb-10">
          {/* 品牌 */}
          <div>
            <a href="#top" className="flex items-center gap-2 mb-3 whitespace-nowrap">
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-play-fill"></i>
              </span>
              <span className="font-heading text-xl text-background-50">吃瓜视频网</span>
            </a>
            <p className="text-sm text-background-300 leading-relaxed max-w-xs">
              打造围观现场，支持弹幕互动与评论热议。让每一个吃瓜群众都能边看边聊，感受最热闹的围观氛围。
            </p>
          </div>

          {/* 导航 */}
          <div>
            <h4 className="font-heading text-base text-background-50 mb-3">快速导航</h4>
            <nav className="grid grid-cols-2 gap-2">
              {footerNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* 联系 */}
          <div id="contact">
            <h4 className="font-heading text-base text-background-50 mb-3">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                hello@chiguavideo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-1-line text-accent-400"></i>
                反馈建议：评论区或私信均可
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                在线围观：全天候不间断
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© 2026 吃瓜视频网 · 全网最热闹的围观现场</p>
          <div className="flex items-center gap-3 text-background-300">
            <a href="#top" aria-label="返回顶部" className="w-8 h-8 rounded-full bg-background-700 hover:bg-primary-500 flex items-center justify-center transition-colors">
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}